import { graphql, useStaticQuery } from "gatsby";

export const useSocialProfiles = () => {
    const rawSocialProfiles = useStaticQuery(graphql`
        query SocialProfilesQuery {
            allContentfulSocialProfile(sort: { index: ASC }) {
                edges {
                    node {
                        network
                        url
                    }
                }
            }
        }
    `);

    return rawSocialProfiles.allContentfulSocialProfile?.edges?.map(
        ({ node }) => {
            return { network: node.network.toLowerCase(), url: node.url };
        }
    );
};
